import { combineReducers } from 'redux'

import requestingReducer from './requestingReducer'
import showCaseReducer from './showCaseReducer'

const comunidadeReducer = combineReducers({
  requesting: requestingReducer,
  showcase: showCaseReducer
})

export default comunidadeReducer



// WEBPACK FOOTER //
// ./src/features/MeuBairro/rootReducer.js